export enum DBOperation {
    create = 1,
    update = 2,
    delete = 3
}

export enum FileType {
    pdf = 1,
    excel = 2
}

// Match with server side enum
export enum RecordStatusType {
    PUKAL = 0,
    BILLING = 1
}

export enum TransactionRecordStatus {
    Status_NEW,
    Status_EXPORTED,
    Status_EXCLUDED
}

export enum PukalAccountStatus {
    ACTIVATE,
    DEACTIVATE,
    TERMINATE
}

export enum OrderBy {
    ACC_No,
    AGENCY_CODE,
    NONE
}

export enum TransactionType {
    FedGov,
    StateGov,
    SwkGov,
    AddMissingTransaction,
    OthAgency
}